import { Box, Button, Card, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiService from "../../../../../../service/Api";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../../../../components/common/ShowToast";
import { MemoryBook } from "../../../../../../types/memory-table";
import { motion } from "framer-motion";
import { CurrentMemoryBookInfo } from "../../../memory-table/components/CurrentMemoryBookInfo";

export const DownloadsTab: React.FC<{ streamId: string }> = ({ streamId }) => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [memoryBooks, setMemoryBooks] = useState<MemoryBook[]>([]);
  const [deliveredBookAvailable, setDeliveredBookAvailable] =
    useState<boolean>(false);

  useEffect(() => {
    fetchMemoryBook();
  }, []);

  const fetchMemoryBook = async () => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await apiService.get<{ results: MemoryBook[] }>(
        `/api/streams/memory-book/?stream=${streamId}`
      );
      console.log(response.data);

      const isDeveliveredBookAvailable = response.data.results.some(
        (memoryBook) => memoryBook.is_delivered
      );
      setDeliveredBookAvailable(isDeveliveredBookAvailable);
      setMemoryBooks(response.data.results);
    } catch (err: any) {
      toast.error("Failed to load comments. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        theme: "light",
      });
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Card
          sx={{
            height: "100%",
            boxShadow: 0,
            borderRadius: "20px",
            padding: "1.2rem",
          }}
        >
          <CircularProgress
            size={25}
            sx={{ display: "block", marginInline: "auto" }}
          />
        </Card>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card
        sx={{
          height: "100%",
          boxShadow: 0,
          borderRadius: "20px",
          padding: "1.2rem",
        }}
      >
        {deliveredBookAvailable ? (
          <CurrentMemoryBookInfo
            memoryBooks={memoryBooks}
            error={error}
            uploadUser={null}
            isAdmin={false}
            isLoading={isLoading}
          />
        ) : (
          <Typography
            variant="body2"
            sx={{ padding: "1.2rem", textAlign: "center" }}
          >
            No downloads available at the moment
          </Typography>
        )}
      </Card>
    </motion.div>
  );
};
